import { cn } from '@/lib/utils';

interface SnapshotDumpSelectorProps {
  apps: string[];
  selected: Set<string>;
  onToggle: (appName: string) => void;
  isPreparing: boolean;
  disabled?: boolean;
  className?: string;
}

export function SnapshotDumpSelector({
  apps,
  selected,
  onToggle,
  isPreparing,
  disabled,
  className,
}: SnapshotDumpSelectorProps) {
  return (
    <span className={cn('flex flex-col items-start gap-1.5', className)}>
      <span className="text-xs text-foreground-muted">
        Attach snapshot dumps for:
      </span>
      <span className="flex flex-wrap gap-1.5">
        {apps.map((appName) => (
          <button
            key={appName}
            type="button"
            onClick={() => onToggle(appName)}
            disabled={disabled}
            className={cn(
              'px-2 py-0.5 rounded-md text-xs border transition-colors disabled:opacity-50',
              selected.has(appName)
                ? 'bg-primary/10 border-primary text-primary'
                : 'bg-background border-border text-foreground-muted hover:border-foreground-muted'
            )}
          >
            {appName}
          </button>
        ))}
      </span>
      {isPreparing && (
        <span className="text-xs text-foreground-muted animate-pulse">
          Preparing snapshot dumps…
        </span>
      )}
    </span>
  );
}
